import { CONFIG } from './_barrel.js';


        // =======================================================================
        // API client
        // =======================================================================
        async function api(path, options = {}, token) {
            const headers = {
                ...(options.headers || {}),
                'Content-Type': 'application/json',
            };
            if (token) headers['Authorization'] = `Bearer ${token}`;

            const resp = await fetch(`${CONFIG.apiBase}${path}`, {
                ...options,
                headers,
            });

            if (resp.status === 204) return null;

            const text = await resp.text();
            const contentType = resp.headers.get('content-type') || '';
            let data = null;
            let parsed = false;
            if (text && contentType.includes('application/json')) {
                try {
                    data = JSON.parse(text);
                    parsed = true;
                } catch (e) {
                    // The body claimed to be JSON but wasn't parseable — treat it
                    // the same as a non-JSON body below rather than letting a raw
                    // SyntaxError escape with no status/context attached.
                }
            }

            if (!resp.ok) {
                // A non-JSON error body (nginx's own HTML error page during a
                // backend restart or 502/504/503, rather than anything FastAPI
                // sent) must not surface as a garbled "Unexpected token '<'"
                // parse error — give a message that says what actually happened.
                const msg = data?.error?.message || data?.detail
                    || (contentType.includes('application/json')
                        ? `HTTP ${resp.status}`
                        : `Server unavailable (HTTP ${resp.status}) — it may be restarting. Try again in a few seconds.`);
                const err = new Error(msg);
                err.status = resp.status;
                err.data = data;
                throw err;
            }
            if (text && !parsed) {
                // 2xx but the body wasn't valid/declared JSON — same defensive
                // treatment, so callers get a clear error instead of a crash.
                // (A JSON `null` body is valid: "no assessment yet" etc.)
                const err = new Error('Server returned an unexpected response. Try again.');
                err.status = resp.status;
                throw err;
            }
            return data;
        }

export { api };
